import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Helpers } from 'src/helpers/helpers';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TplPurchaseService extends BaseService {

  constructor(private http: HttpClient,  helper: Helpers) {
    super(helper);
 }
 private pathAPI = environment.apiUrl;


  getOrderById(id: any) {
    return this.http.get<any>(this.pathAPI + 'TPLPurchase/' + id, super.header()).pipe(catchError(super.handleError));
  }
}
